<template>
  <div class="OSDIALTable">
    <v-container fluid grid-list-lg text-xs-center>
      <v-layout row wrap>
        <v-flex xs6>
          <v-flex height="100%">
            <v-card v-if="load" class="mb-2" >
              <v-card-title class="title">
                Marcaciones
                <v-spacer/>
                <v-card-actions>
                  <v-btn color="info" :disabled="dataVals === null">
                    <download-csv
                    :data="dataVals"
                    name="Reportes Osdial.csv"
                    :labels="labels"
                    >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions>
            </v-card-title>

            <v-card-text
            v-if="loading"
            class="text-xs-center"
            >
            <v-progress-circular
            :size="progressSize"
            :width="progressWidth"
            color="info"
            indeterminate
            ></v-progress-circular>
          </v-card-text>

          <v-card-text v-else>
            <data-table
            :headers="headers"
            :dataVals="dataVals"
            :items="dataVals"
            :key="tableKey"
            />
          </v-card-text>
        </v-card>
      </v-flex>
    </v-flex>
    <v-flex xs6>
      <v-flex height="100%">
        <v-card v-if="load1" class="mb-2" >
          <v-card-title class="title">
            Incidencia
            <v-spacer/>

            <v-card-actions>
              <v-btn color="info" :disabled="dataVals_inc === null">
                <download-csv
                :data="dataVals_inc"
                name="Reporte_Incidencia_Campania.csv"
                :labels="labels"
                >
                <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
              </download-csv>
            </v-btn>
          </v-card-actions>
        </v-card-title>

        <v-card-text
        v-if="loading1"
        class="text-xs-center"
        >
        <v-progress-circular
        :size="progressSize"
        :width="progressWidth"
        color="info"
        indeterminate
        ></v-progress-circular>
      </v-card-text>

      <v-card-text v-else>
        <data-table
        :headers="headers_inc"
        :dataVals="dataVals_inc"
        :items="dataVals_inc"
        :key="tableKey1"
        />
      </v-card-text>
    </v-card>
  </v-flex>
</v-flex>
</v-layout>
</v-container>
<v-container>
  <v-layout row wrap justify-center>
    <v-flex xs6 >
      <v-flex height="100%">
        <v-card v-if="load2" class="mb-2" >
          <v-card-title class="title">
            Agente
            <v-spacer/>

            <v-card-actions>
              <v-btn color="info" :disabled="dataVals_age === null || selectedAgente === null">
                <download-csv
                :data="dataVals_age"
                :name="'Reporte_Agente.csv' + selectedAgente + '.csv'"
                :labels="labels"
                >
                <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
              </download-csv>
            </v-btn>
          </v-card-actions>
        </v-card-title>
        <v-autocomplete class="mx-2 px-2"
          :items="savedAgentes"
          label="Seleccione el agente"
          v-model="selectedAgente"
          color="secondary"
          item-text="nombre"
          return-object
          no-data-text="No se tienen Agentes."
        ></v-autocomplete>
        <v-card-text
        v-if="loading2"
        class="text-xs-center"
        >
        <v-progress-circular
        :size="progressSize"
        :width="progressWidth"
        color="info"
        indeterminate
        ></v-progress-circular>
      </v-card-text>

      <v-card-text v-else>
        <data-table
        :headers="headers_age"
        :dataVals="dataVals_age"
        :items="dataVals_age"
        :key="tableKey2"
        />
      </v-card-text>
    </v-card>
  </v-flex>
</v-flex>
</v-layout>
</v-container>
</div>
</template>

<script>
import dataTable from '@/components/Tables/TableBase'
import JsonCSV from 'vue-json-csv'

export default {
  name: 'OSDIALTable',

  components: {
    'data-table': dataTable,
    'download-csv': JsonCSV
  },

  /**
  * Esta función carga el respectivo Layout, al crear la vista.
  */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.operativo = this.$store.state.actualOperation.id
  },

  data: function () {
    return {
      backConf: {
        path: '/callcenter/osdial-remarcaciones/?operativo=78',
        path1: '/callcenter/camp-inc/?operativo=78',
        path2: '/callcenter/agente/?operativo=78',
        page: 1
      },

      loading: false,
      loading1: false,
      loading2: false,
      progressSize: 70,
      progressWidth: 7,
      operativo: null,

      headers: [
        { text: 'Marcaciones', value: 'marcacion', align: 'left' },
        { text: 'Total', value: 'total', align: 'left' }
      ],

      headers_inc: [
        { text: 'Incidencia', value: 'incidencia', align: 'left' },
        { text: 'Total', value: 'total', align: 'left' }
      ],
      savedAgentes: [],
      selectedAgente: null,
      headers_age: [
        { text: 'Incidencia', value: 'agente', align: 'left' },
        { text: 'Total', value: 'total', align: 'left' }
      ],

      dataVals: null,
      load: false,
      tableKey: 0,
      dataVals_inc: null,
      load1: false,
      tableKey1: 0,
      dataVals_age: null,
      load2: false,
      tableKey2: 0

    }
  },

  watch: {
    operativo: function () {
      this.loadData()
      this.loadData1()
      this.loadData2()
    }

  },
  methods: {
    /** Carga la tabla
    */
    loadTable () {
      this.dataVals = null
      this.loading = true
      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {
          operativo: this.operativo
        }
      }
      let t = this

      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataVals = resp.data
          t.loading = false
          t.tableKey += 1
        })
        .catch(function (err) {
          t.dataVals = []
          t.loading = false
          t.tableKey += 1
          console.error(err)
        })
    },

    loadTable1 () {
      this.dataVals_inc = null
      this.loading1 = true
      let request = {
        method: 'get',
        url: this.backConf.path1,
        params: {
          operativo: this.operativo
        }
      }
      let t = this

      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataVals_inc = resp.data
          t.loading1 = false
          t.tableKey1 += 1
        })
        .catch(function (err) {
          t.dataVals_inc = []
          t.loading1 = false
          t.tableKey1 += 1
          console.error(err)
        })
    },
    loadTable2 () {
      this.dataVals_age = null
      this.loading2 = true
      let request = {
        method: 'get',
        url: this.backConf.path2,
        params: {
          operativo: this.operativo
        }
      }
      let t = this

      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataVals_age = resp.data
          t.loading2 = false
          t.tableKey2 += 1
        })
        .catch(function (err) {
          t.dataVals_age = []
          t.loading2 = false
          t.tableKey2 += 1
          console.error(err)
        })
    },

    loadData () {
      this.load = true
      this.loadTable()
    },
    loadData1 () {
      this.load1 = true
      this.loadTable1()
    },
    loadData2 () {
      this.load2 = true
      this.loadTable2()
    }

  }
}
</script>
